import { render, staticRenderFns } from "./FormSavedSuccess.vue?vue&type=template&id=1d31a136&scoped=true"
import script from "./FormSavedSuccess.vue?vue&type=script&lang=js"
export * from "./FormSavedSuccess.vue?vue&type=script&lang=js"
import style0 from "./FormSavedSuccess.vue?vue&type=style&index=0&id=1d31a136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d31a136",
  null
  
)

export default component.exports